<template>
  <v-container class="py-8" style="max-width: 900px;">
    <!-- Тексты статичны и лежат в src/legal/, пользовательского ввода в них нет -->
    <div class="legal-document" lang="ru" v-html="html" @click="handleLinkClick"></div>
  </v-container>
</template>

<script>
import { marked } from 'marked'
import { fillLegalText } from '@/config/legal'
import privacy from '@/legal/privacy'
import terms from '@/legal/terms'
import requisites from '@/legal/requisites'
import consentAccount from '@/legal/consentAccount'
import consentTelegram from '@/legal/consentTelegram'
import consentNews from '@/legal/consentNews'

const DOCUMENTS = { privacy, terms, requisites, consentAccount, consentTelegram, consentNews }

export default {
  name: 'LegalDocument',
  props: {
    doc: { type: String, required: true }
  },
  computed: {
    html() {
      return marked.parse(fillLegalText(DOCUMENTS[this.doc] || ''))
    }
  },
  methods: {
    // Внутренние ссылки открываются без перезагрузки страницы
    handleLinkClick(event) {
      const link = event.target.closest('a')
      const href = link?.getAttribute('href')
      if (href && href.startsWith('/')) {
        event.preventDefault()
        this.$router.push(href)
      }
    }
  }
}
</script>

<style scoped>
.legal-document :deep(h1) {
  font-size: 1.6rem;
  line-height: 1.3;
  margin-bottom: 16px;
}
.legal-document :deep(h2) {
  font-size: 1.15rem;
  margin: 28px 0 10px;
}
.legal-document :deep(p),
.legal-document :deep(li) {
  line-height: 1.6;
  text-align: justify;
  hyphens: auto;
}
.legal-document :deep(p) {
  margin-bottom: 12px;
}
.legal-document :deep(ul) {
  margin: 0 0 12px 24px;
}
/* В ячейках таблиц текст по левому краю: в узких колонках выравнивание по ширине рвёт строки */
.legal-document :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
  font-size: 0.9rem;
}
.legal-document :deep(th),
.legal-document :deep(td) {
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 8px 10px;
  text-align: left;
  vertical-align: top;
}
.legal-document :deep(a) {
  color: rgb(var(--v-theme-primary));
  text-decoration: underline;
}
</style>
